<template>
    <div class="toufang2_main">
        <div class="toufang21">
            <img src="../img/toufang0711/落地页切图/1.jpg" @click="handleClick" alt="">
            <div class="toufang21_box2">
                <img src="../img/toufang0711/落地页切图/2.jpg" alt="">
                <div class="toufang21_btn toufang21_btn1" @click="handleClick">
                    <img src="../img/toufang0708/111.png" alt="">
                    <p>立即咨询</p>
                </div>
                <div class="toufang21_btn toufang21_btn2" @click="handleClick">
                    <img src="../img/toufang0708/111.png" alt="">
                    <p>立即咨询</p>
                </div>
            </div>
            <img src="../img/toufang0711/落地页切图/3.jpg" alt="" @click="handleClick">
            <img src="../img/toufang0711/落地页切图/4.jpg" alt="">
            <div class="toufang21_box5">

                <img src="../img/toufang0711/落地页切图/5.jpg" alt="">
                <div class="toufang21_btn toufang21_btn1" @click="handleClick">
                    <img src="../img/toufang0708/111.png" alt="">
                    <p>立即咨询</p>
                </div>
                <div class="toufang21_btn toufang21_btn2" @click="handleClick">
                    <img src="../img/toufang0708/111.png" alt="">
                    <p>立即咨询</p>
                </div>
            </div>
        </div>

        <div class="toufang22">
            <div class="swiper mySwiperTF1">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <img src="../img/toufang0711/轮播页切图/各国轮播/1.png" alt="">
                    </div>
                    <div class="swiper-slide">
                        <img src="../img/toufang0711/轮播页切图/各国轮播/2.png" alt="">
                    </div>
                    <div class="swiper-slide">
                        <img src="../img/toufang0711/轮播页切图/各国轮播/3.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="toufang22">
            <img src="../img/toufang0711/落地页切图/6.jpg" alt="" style="width: 100%;">
            <div class="swiper mySwiperTF1">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <img src="../img/toufang0711/轮播页切图/专业轮播/专业轮播.png" alt="">
                    </div>
                    <div class="swiper-slide">
                        <img src="../img/toufang0711/轮播页切图/专业轮播/专业轮播2.png" alt="">
                    </div>

                </div>
                <div class="swiper2_btn_box">
                    <div class="toufang21_btn toufang21_btn1" @click="handleClick">
                        <img src="../img/toufang0708/111.png" alt="">
                        <p>立即咨询</p>
                    </div>
                    <div class="toufang21_btn toufang21_btn2" @click="handleClick">
                        <img src="../img/toufang0708/111.png" alt="">
                        <p>立即咨询</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="toufang22">
            <img src="../img/toufang0711/落地页切图/7.jpg" alt="" style="width: 100%;">
            <div class="swiper mySwiperTF1">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <img src="../img/toufang0711/轮播页切图/导师轮播/1.png" alt="">
                    </div>
                    <div class="swiper-slide">
                        <img src="../img/toufang0711/轮播页切图/导师轮播/2.png" alt="">
                    </div>

                </div>
                <div class="swiper2_btn_box">
                    <div class="toufang21_btn toufang21_btn1" @click="handleClick">
                        <img src="../img/toufang0708/111.png" alt="">
                        <p>立即咨询</p>
                    </div>
                    <div class="toufang21_btn toufang21_btn2" @click="handleClick">
                        <img src="../img/toufang0708/111.png" alt="">
                        <p>立即咨询</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="toufang22">
            <img src="../img/toufang0711/落地页切图/8.jpg" alt="" style="width: 100%;">
            <div class="swiper mySwiperTF1">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <img src="../img/toufang0711/轮播页切图/学历轮播/1.png" alt="">
                    </div>
                    <div class="swiper-slide">
                        <img src="../img/toufang0711/轮播页切图/学历轮播/2.png" alt="">
                    </div>

                </div>
                <div class="swiper5_btn_box">
                    <div class="toufang21_btn toufang21_btn1" @click="handleClick">
                        <img src="../img/toufang0708/111.png" alt="">
                        <p>立即咨询</p>
                    </div>
                    <div class="toufang21_btn toufang21_btn2" @click="handleClick">
                        <img src="../img/toufang0708/111.png" alt="">
                        <p>立即咨询</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="toufang22">
            <img src="../img/toufang0711/落地页切图/9.jpg" alt="" style="width: 100%;">
            <div class="swiper6_btn_box">
                <div class="toufang21_btn toufang21_btn1" @click="handleClick">
                    <img src="../img/toufang0708/111.png" alt="">
                    <p>立即咨询</p>
                </div>
                <div class="toufang21_btn toufang21_btn2" @click="handleClick">
                    <img src="../img/toufang0708/111.png" alt="">
                    <p>立即咨询</p>
                </div>
            </div>
        </div>
        <div class="toufang22">
            <img src="../img/toufang0711/落地页切图/10.jpg" alt="" style="width: 100%;">
            <img src="../img/toufang0711/落地页切图/11.jpg" alt="" style="width: 100%;">
        </div>

        <div class="toufang21" style="margin-bottom: 2rem">
            <img src="../img/toufang0711/落地页切图/121.jpg" alt="">
            <div style="font-size: .17rem;width: 88%;margin: 0 auto;text-align: center;padding: 0 0 .1rem;">
            Copyright © 2020-2024 上海洛素文化艺术有限公司, All Rights Reserved.
            </div>
        </div>

        <div class="toufang21 toufang2_fix_box">
            <img src="../img/toufang0711/落地页切图/122.jpg" alt="">
            <div class="bot_box">
                <div class="bot_item" @click="telhandle"></div>
                <div class="bot_item" @click="handleClick"></div>
                <div class="bot_item" @click="handleClick"></div>
                <div class="bot_item" @click="wechathandle"></div>
            </div>
        </div>



    </div>
</template>

<script>
import '@/assets/css/toufang2.css'
import Swiper from 'swiper/bundle'
import 'swiper/css';
import "swiper/css/effect-cards";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
export default {

    methods: {

        handleClick() {
            var msg_tip = document.getElementById("msg_tip")
            msg_tip.click()
        },

        getNavFoot() {
            var section_bot = document.getElementsByClassName("section_bot")
            var nav_bottom = document.getElementsByClassName("nav_bottom")
            var nav = document.getElementsByTagName("nav")

            section_bot[0].style.display = "none"
            nav[0].style.display = "none"
            nav_bottom[0].style.display = "none"
            // mobile_minchat_div.style.display = "none"
            // console.log(,nav[0]);
        },
        mySwiperTF1() {
            var swiper = new Swiper(".mySwiperTF1", {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                observer: true,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
        telhandle() {
            window.location.href = 'tel:' + '4000999530';
        },
        wechathandle() {
            window.location.href = 'https://work.weixin.qq.com/ca/cawcde66b4be07d3dd'
        },
    },
    created() {
        this.getNavFoot()
    },
    mounted() {
        this.getNavFoot()
        this.mySwiperTF1()
    }

}
</script>

<style></style>